import React = require('react');
import Toggle from "material-ui/Toggle";
import {autoprefixer} from "diy/material-ui/autoprefixer";

export interface ToggleItem {
    id: string;
    label: string;
    toggled: boolean;
}
export interface ToggleGroups {
    groupName: string;
    toggles: ToggleItem[];
}

export interface TogglesViewProps extends React.Props<TogglesView> {
    onToggleSwitch: Function;
    toggles: ToggleGroups[];
}

interface TogglesViewState {}

export default class TogglesView extends React.Component<TogglesViewProps, TogglesViewState> {
    renderGroupToggles() {
        return this.props.toggles.map((group: ToggleGroups, groupIndex: number) => {
            let style: React.CSSProperties = autoprefixer({
                display: 'flex',
                flexDirection: 'column'
            });

            let isLastGroup = groupIndex === (this.props.toggles.length - 1);

            if (!isLastGroup) {
                Object.assign(
                    style, {
                        borderBottom: '1px dotted #ccc',
                        marginBottom: 20
                    }
                );
            }

            return <div style={style} key={'toggle-group-' + groupIndex}>
                <div
                    style={{
                        fontFamily: "open sans",
                        fontSize: '14px',
                        lineHeight: '14px',
                        paddingBottom: '10px',
                        color: '#666'
                    }}
                >{group.groupName}</div>
                {group.toggles.map((toggleItem, toggleIndex)  => {
                    let isLastToggleInGroup = toggleIndex === (group.toggles.length - 1);
                    return <Toggle
                        label={toggleItem.label}
                        toggled={toggleItem.toggled}
                        style={autoprefixer({
                            marginBottom:  isLastToggleInGroup && isLastGroup ? 0 : 10,
                            display: 'block',
                            width: 'auto',
                            flexGrow: 1
                        })}
                        key={'toggle-item-' + toggleItem.id}
                        onToggle={() => {
                            let groupToggles = Object.assign({}, this.props.toggles);
                            groupToggles[groupIndex].toggles[toggleIndex].toggled = !toggleItem.toggled;
                            this.props.onToggleSwitch(groupToggles);
                        }}
                        labelStyle={{
                            marginRight: 30,
                            width: 'calc(100% - 76px)'
                            /* 46px the width of the toggle button + 30px the label right margin*/
                        }}
                        data-test-id={"section-toggle-" + toggleItem.id}
                    />;
                })}
            </div>;
        });
    }
    render() {
        return <div>{this.renderGroupToggles()}</div>;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/basic/TogglesView.tsx
 **/